import { fields } from "@monorepo/utils/src/variables/projectsData/MonitoringBussinessProccesesView/fields";
import moment from "moment";

export const currentFilters = (): Record<string, string> => ({
  [fields.PERIOD_FIlTER_TO]: moment().endOf("day").format("YYYY-MM-DD"),
  [fields.PERIOD_FIlTER_FROM]: moment().add(-7, "day").startOf("day").format("YYYY-MM-DD"),
});
